import React, {useState} from 'react';
import TablePastClasses from './TablePastClasses';
import TableFutureClasses from './TableFutureClasses';
import {Form, Row,Col} from "react-bootstrap"
import { useDispatch } from 'react-redux';
import { setClasses } from '../../../store/class/class.slice';
const StudentClasses = () => {
    const [checked,setChecked] = useState(false)
    const dispatch = useDispatch()
    return (
        <>
            {checked
                ?
                <>
                    <Row className="justify-content-md-center">
                        <Col  xs={2}>
                            <Form.Check 
                                type="switch"
                                id="custom-switch"
                                label="Ver próximas clases"
                                checked={checked}
                                onClick ={() => {
                                    dispatch(setClasses([]))
                                    setChecked(!checked)
                                }}
                            />
                        </Col>
                    </Row>
                    
                    
                    <br/>
                    <TablePastClasses />
                </>
                :
                <>
                    <Row className="justify-content-md-center">
                        <Col  xs={2}>
                            <Form.Check 
                                type="switch"
                                id="custom-switch"
                                label="Ver clases pasadas"
                                checked={checked}
                                onClick ={() => {
                                    dispatch(setClasses([]))
                                    setChecked(!checked)
                                }}
                            />
                        </Col>
                    </Row>
                    <br/>
                    <TableFutureClasses />
                </>
            }
        </>
    )
}

export default StudentClasses